import _ from 'lodash'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const TOAST_SUCCESS_DURATION = 3000
const DEFAULT_TOAST_DURATION = 5000

function _notify(value, autoCloseDuration = DEFAULT_TOAST_DURATION) {
  if (!value) return

  const message = _.upperFirst(_.get(value, 'message') || value)
  const type = _.get(value, 'type') || 'info'

  toast[type](<div>{message}</div>, { autoClose: autoCloseDuration })
}

function notifyError(message = 'Sorry, something went wrong') {
  _notify({
    message,
    type: 'error',
  })
}

function notifySuccess(message) {
  _notify(
    {
      message,
      type: 'success',
    },
    TOAST_SUCCESS_DURATION
  )
}

function notifyInfo(message) {
  _notify({
    message,
  })
}

export default {
  DEFAULT_TOAST_DURATION,
  notifyError,
  notifySuccess,
  notifyInfo,
}
